import { useCallback } from 'react';
import useConversationStore from '@/stores/ConversationStore';

const useShortUrlChange = () => {
  const setGlobalNotify = useConversationStore((state) => state.setGlobalNotify);

  const apiPrefix = {
    "japanhighlights.com": "https://www.japanhighlights.com/index.php",
    "chinahighlights.com": "https://www.chinahighlights.com/guide-use.php",
    "highlightstravel.com": "https://www.highlightstravel.com/index.php",
    "asiahighlights.com": "https://www.asiahighlights.com/index.php",
    "globalhighlights.com": "https://www.globalhighlights.com/index.php",
  };

  const fetchNowConversationsitems = async (base64Url, apiUrl) => {
    try {
      const formData = new FormData();
      formData.append(' url', base64Url);
      formData.append('type', 'info');
      const response = await fetch(`${apiUrl}/apps/short_link/index/create`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data[0].name == 'ok') {
        return data[0].value;
      }
      return null;
    } catch (error) {
      console.error('获取短链接转换内容失败:', error);
      return null;
    }
  };

  const urlBase64 = (longUrl) => {
    try {
      const extracted2 = longUrl.match(/https:\/\/www\.([^\/]+)/)?.[1] || '';

      const encoder = new TextEncoder();
      const utf8Bytes = encoder.encode(longUrl);
      const base64Url = btoa(String.fromCharCode(...utf8Bytes));

      return { base64Url, extracted2 };
    } catch (error) {
      setGlobalNotify([{
        key: Date.now().toString(),
        title: '错误',
        content: '转换失败，请检查输入的URL是否正确',
        type: 'error'
      }]);
      console.error('URL转换错误:', error);
      return { base64Url: '', extracted2: '' };
    }
  };
  const normalizeUrl = (longUrl) => {
    try {
      const hasProtocol = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(longUrl);
      const url = new URL(hasProtocol ? longUrl : `http://${longUrl}`);
      const params = Object.fromEntries(url.searchParams.entries());

      return {
        url: url.href,
        valid: true,
        origin: url.origin,
        hostname: url.hostname,
        pathname: url.pathname,
        params
      };
    } catch (e) {
      return { valid: false, error: "Invalid URL" };
    }
  };
  const convertUrl = useCallback(async (longUrl) => {
    const normalizedUrl = normalizeUrl(longUrl);
    if (!normalizedUrl.valid || Object.keys(normalizedUrl?.params || {}).length === 0) {
      setGlobalNotify([{
        key: Date.now().toString(),
        title: '错误',
        content: '没有需要转换的长链接, 请重新输入',
        type: 'warning'
      }]);
      return null;
    }

    const { base64Url, extracted2 } = urlBase64(normalizedUrl.url);

    if (base64Url) {
      const apiUrl = apiPrefix[extracted2] || apiPrefix["chinahighlights.com"];
      const extracted1 = apiUrl.match(/^https?:\/\/[^\/]*\.com/)?.[0] || '';

      const data = await fetchNowConversationsitems(base64Url, apiUrl);
      if (data) {
        const resultShortUrl = extracted1 + data.isl_link;
        setGlobalNotify([{
          key: Date.now().toString(),
          title: '成功',
          content: '转换成功！',
          type: 'success'
        }]);
        return resultShortUrl;
      } else {
        setGlobalNotify([{
          key: Date.now().toString(),
          title: '错误',
          content: '转换失败，请检查输入的URL是否正确！',
          type: 'error'
        }]);
        return null;
      }
    } else {
      setGlobalNotify([{
        key: Date.now().toString(),
        title: '错误',
        content: 'URL格式不正确，请输入完整的URL',
        type: 'error'
      }]);
      return null;
    }
  }, [setGlobalNotify]);

  return { convertUrl };
};

export default useShortUrlChange;
